import type {ErrorMessage} from 'angular-error-repository';

export const IbanError: ErrorMessage = () => {
    return 'Error.IBAN';
};
